import Vue from "vue";
import i18n from "@/translations/i18n"
import VueRouter from "vue-router";
import DeliveryDetails from "@/views/delivery/DeliveryDetails.vue";
import ShoppingCart from "@/views/cart/ShoppingCart.vue";
import ChooseSeatFlow from "@/views/ChooseSeatFlow.vue";
import NotFound from "@/views/NotFound.vue";
import Login from "@/views/Login.vue";
import CartConfirmation from "@/views/cart/CartConfirmation.vue";
import Payment from "@/views/payment/Payment.vue";
import PaymentFail from "@/views/payment/PaymentFail.vue";
import RegistrationDetails from "@/views/registration/RegistrationDetails.vue"
import RegistrationSuccess from "@/views/registration/RegistrationSuccess.vue"
import ChooseDateTime from "@/views/ChooseDateTime.vue"
import store from "@/store"
import PreCartCheck from "@/views/cart/PreCartCheck.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/:locale/login",
    name: "login",
    component: Login,
  },
  {
    path: "/:locale/event/:icc/:issue?",
    name: "choose-seat-flow",
    component: ChooseSeatFlow,
  },
  {
    path: "/:locale/cart/address",
    name: "delivery-details",
    component: DeliveryDetails,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: "/:locale/cart/processing/:icc",
    name: "pre-cart",
    component: PreCartCheck,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: "/:locale/cart/payment",
    name: "payment",
    component: Payment,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: "/:locale/cart/confirmation",
    name: "cart-confirmation",
    component: CartConfirmation,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: "/:locale/cart/failed",
    name: "payment-failed",
    component: PaymentFail,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: "/:locale/cart",
    name: "shopping-cart",
    component: ShoppingCart,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: "/:locale/registration/:event/details",
    name: "registration-details",
    component: RegistrationDetails,
  },
  {
    path: "/:locale/registration/:event/success",
    name: "registration-success",
    component: RegistrationSuccess,
  },
  {
    path: "/:locale/registration/:event",
    name: "registration-flow",
    component: ChooseDateTime,
  },
  // * denotes any matched path that is not above. I.e. redirect to ShoppingCart if we can't find the route
  // if the user doesn't have a cart, login in ShoppingCart will push them to EmptyCart.
  {
    path: "*",
    name: "not-found",
    component: NotFound,
  },
];

const router = new VueRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes,
  mode: 'history'
});

const traditionalTitle = "西九文化區 - 購票頁面"
const simplifiedTitle = "西九文化区 - 购票页面"
const englishTitle = "WestK - Booking Page"

router.beforeEach((to, from, next) => {
  if (to.params.locale == undefined) {
    if (i18n.locale != undefined) {
      to.params.locale = i18n.locale;
    } else {
      to.params.locale = "en"
    }
  }

  let documentTitle = englishTitle;

  if (i18n.locale == 'sc') {
    documentTitle = simplifiedTitle;
  } else if (i18n.locale == 'tc') {
    documentTitle = traditionalTitle;
  } else {
    documentTitle = englishTitle;
  }

  // Set Title in Browser
  document.title = documentTitle

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // On each route that requires login we make a request to the
    // backend to see if we are still logged in.
    store.dispatch('retrieveUserDetails').then(() => {
      if (!store.state.user.userLoggedIn) {
        next({
          name: 'login',
          params: {
            locale: i18n.locale
          }
        })
      } else {
        next()
      }
    });
  } else if (to.name == "not-found" && to.path.indexOf("event") != -1) {
    // If a user navigates directly to /event/:icc (opposed to /:locale/event/:icc)
    // Then vue-router sends them to not-found; here we try to redirect them to the relevant performance listings
    let eventUrlArray = to.path.split('/')
    let iccIndex = eventUrlArray.findIndex((element) => element == "event") + 1;

    if (iccIndex != -1) {
      next({
        name: "choose-seat-flow",
        params: {
          locale: i18n.locale,
          icc: eventUrlArray[iccIndex]
        }
      });
    } else {
      next();
    }
  } else if (to.name == "not-found" && to.path.indexOf("registration") != -1) {
    // If a user navigates directly to /registration/:event (opposed to /:locale/registration/:event)
    // Then vue-router sends them to not-found; here we try to redirect them to the relevant performance listings
    let registrationUrlArray = to.path.split('/')
    let registrationIndex = registrationUrlArray.findIndex((element) => element == "registration") + 1;

    if (registrationIndex != -1) {
      next({
        name: "registration-flow",
        params: {
          locale: i18n.locale,
          event: registrationUrlArray[registrationIndex]
        }
      });
    } else {
      next();
    }
  } else if (to.name == "not-found" && to.path.indexOf("failed") != -1) {
    // If we found failed; we should be heading to payment failed page
    next({
      name: "payment-failed",
      params: {
        locale: i18n.locale
      },
      query: to.query
    });
  } else if ((to.name == "not-found" && to.path.indexOf("cart") != -1) || (to.name == "choose-seat-flow" && to.params.icc == "")) {
    // If we're redirecting to cart confirmation screen, go there
    if (to.path.indexOf("confirmation") != -1) {
      next({
        name: "cart-confirmation",
        params: {
          locale: i18n.locale
        },
        query: to.query
      });
    } else {
      // If we've gone to /cart (and not on confirmation screen); or no icc code is provided to choose-seat-flow
      // Then go to shopping cart
      next({
        name: "shopping-cart",
        params: {
          locale: i18n.locale
        }
      });
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router;
